import { createGlobalStyle, css } from "styled-components";

export const narrowScreenMediaQuery = "screen and (max-width: 719px)";

const GlobalCSS = css`
  [data-error] {
    /* overcome specificity for onboarding-form-helpers */
    && {
      border: 1px solid #da3333;
    }
  }

  html {
    --sticky-height: 0;
    scroll-padding-top: calc(1px * var(--sticky-height));

    & body {
      margin: 0;
      & * {
        font-family: sans-serif;
      }
    }
  }
`;

export const GlobalStyle = createGlobalStyle(GlobalCSS);
